import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_TH_UQ || "uq.th.new-styling-book",
  ugcClientId: process.env.REACT_APP_UGC_CLIENT_ID_TH_UQ || "uqth-sth-sb-proxy",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_TH_UQ || 27519,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_TH_UQ || 27520,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_TH_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_TH_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_TH_UQ || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_TH_UQ || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.EN, LANGUAGE.TH],
  countryRegion: "Asia/Bangkok",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "ICT",
      offset: {
        ICT: +7,
        "GMT+7": +7
      }
    },
    [LANGUAGE.TH]: {
      defaultTimezone: "ICT",
      offset: {
        ICT: +7,
        "GMT+7": +7
      }
    }
  },
  timeZoneParentCategory: {
    "GMT+7": "ICT"
  },
  dateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>",
    [LANGUAGE.TH]: "<dd>/<mm>/<yyyy>"
  },
  shortDateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>",
    [LANGUAGE.TH]: "<dd>/<mm>"
  },
  requireDecimal: true,
  memberPricingEnabled: false
};

export default _countryEnv;
